module.exports = __webpack_public_path__ + "img/rg-target-object-safe-default.78b4895a.svg";